import React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { ROUTE } from '@/constants/route';
import { useDemoContext } from '@/hooks/DemoContext';
import { useAuth } from '@/hooks/useAuth';
import { isRouteAllowedInDemo } from '@/utils/functions/isRouteAllowedInDemo/isRouteAllowedInDemo';

import type { JSX } from 'react';

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user } = useAuth();
  const { isDemo } = useDemoContext();
  const { pathname } = useLocation();

  if (!user && !isDemo) {
    return <Navigate to={ROUTE.LOGIN} replace />;
  }

  if (isDemo && !isRouteAllowedInDemo(pathname)) {
    return <Navigate to={ROUTE.DASHBOARD} replace />;
  }

  return children;
};

export default ProtectedRoute;
